module.exports = __webpack_public_path__ + "static/img/s124.8521bba7.png";